const NeedUploadHint = () => {
    return <div className='p-2'>
        <div className="row">
            <div className="col alert alert-info">
                To change settings, first upload the file
            </div>
        </div>
    </div>
}

export default NeedUploadHint